import styled from 'styled-components';

export const SideMenuElement = styled.div<{ isOpened: boolean }>`
  position: absolute;
  max-width: 1024px;
  margin-inline: auto;
  left: 1.5rem;
  height: 100vh;
  @media all and (max-width: 1880px) {
    display: ${(props) => (props.isOpened ? 'flex' : 'none')};
    justify-content: flex-start;
    margin: auto;
    inset: 0;
  }
`;

export const SideMenuOverlay = styled.div<{ isOpened: boolean }>`
  position: absolute;
  top: -10px;
  bottom: 0;
  left: -5000px;
  right: -5000px;
  /* z-index juste en dessous de MenuCard (900) et Header (1000) */
  z-index: 899;
  background-color: rgba(0, 0, 0, 0.18); /* #0000002E */
  display: none;
  @media all and (max-width: 1880px) {
    display: ${(props) => (props.isOpened ? 'block' : 'none')};
  }
`;
